import {
    ProductDto,
    ProductUnitDto
} from '@eurogast/hub-client-typescript';
import Nara from '@/domain/product/Nara';

export class Cart {
    public customerId: string;
    public userId: string;
    public items: CartItem[];
    public validSince?: Date;
    public deletedItems: DeletedCartItem[];

    constructor(
      customerId: string,
      userId: string,
      items: CartItem[],
      validSince: Date,
      deletedItems: DeletedCartItem[]
    ) {
        this.customerId = customerId;
        this.userId = userId;
        this.items = items;
        this.validSince = validSince;
        this.deletedItems = deletedItems;
    }
}

export class CartItem {
    public sku: string;
    public amount: number;
    public unitAbbreviation: string;
    public unit?: ProductUnitDto;
    public product?: ProductDto;
    public lastUpdatedAt?: Date;
    public naras: Nara[] = [];
    public removed = false;

    public static buildWithDefaults(
      itemWithoutProduct: {
          sku: string,
          amount: number,
          unitAbbreviation: string
      }
    ): CartItem {
        return new CartItem(
          itemWithoutProduct.sku,
          itemWithoutProduct.amount,
          itemWithoutProduct.unitAbbreviation,
          null,
          null,
          null
        );
    }

    public static buildWithUnit(
        sku: string,
        amount: number,
        unit: ProductUnitDto
    ): CartItem {
        return new CartItem(
          sku,
          amount,
          !unit ? '' : unit.abbreviation,
          unit,
          null,
          null
        );
    }

    public clone(): CartItem {
        return new CartItem(
          this.sku,
          this.amount,
          this.unitAbbreviation,
          this.unit,
          this.product,
          this.lastUpdatedAt
        );
    }

    constructor(
      sku: string,
      amount: number,
      unitAbbreviation: string,
      unit: ProductUnitDto,
      product: ProductDto,
      lastUpdatedAt: Date
    ) {
        this.sku = sku;
        this.amount = amount;
        this.unitAbbreviation = unitAbbreviation;
        this.unit = unit;
        this.product = product;
        this.lastUpdatedAt = lastUpdatedAt;
    }
}

export class DeletedCartItem {
   public sku: string;
   public unitAbbr: string;
   public deletedAt: string;

    constructor(sku: string, unitAbbr: string, deletedAt: string) {
        this.sku = sku;
        this.unitAbbr = unitAbbr;
        this.deletedAt = deletedAt;
    }
}
